import { Flex } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { WidgetSettingsListItem } from '@shared/api';
import { DateService } from '@shared/services/date';
import { Table } from '@shared/ui/table';
import { PresetSettings } from './preset-settings';

interface PresetsTableProps {
  presets: WidgetSettingsListItem[];
  onEdit: (presetId: number) => void;
  onDelete: (presetId: number) => void;
  isDeleting?: boolean;
}

export const PresetsTable: FC<PresetsTableProps> = ({
  presets,
  onEdit,
  onDelete,
  isDeleting = false,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets.table' });

  return (
    <Table maxHeight="calc(100vh - 200px)">
      <Table.THead isSticky>
        <Table.THeadCellText width={240}>{t('name')}</Table.THeadCellText>
        <Table.THeadCellText width={420}>{t('description')}</Table.THeadCellText>
        <Table.THeadCellText width={200}>{t('createdAt')}</Table.THeadCellText>
        <Table.THeadCellText width={200}>{t('updatedAt')}</Table.THeadCellText>
        <Table.THeadCellText
          width={100}
          style={{ textAlign: 'center' }}
          textStyle={{ textAlign: 'center' }}
        >
          <></>
        </Table.THeadCellText>
      </Table.THead>

      <Table.TBody>
        {presets.map((preset) => (
          <Table.TRow key={preset.id}>
            <Table.TCellTextTooltip maxLength={30} variant="sm" text={preset.name} />
            <Table.TCellTextTooltip maxLength={60} variant="sm" text={preset.description || '-'} />
            <Table.TCellText variant="sm" fontWeight={400}>
              {DateService.format(preset.created_at, 'DD.MM.YYYY HH:mm')}
            </Table.TCellText>
            <Table.TCellText variant="sm" fontWeight={400}>
              {DateService.format(preset.updated_at, 'DD.MM.YYYY HH:mm')}
            </Table.TCellText>
            <Table.TCell align="center" style={{ padding: 0 }}>
              <Flex align="center" justify="center">
                <PresetSettings
                  onEdit={() => onEdit(preset.id)}
                  onDelete={() => onDelete(preset.id)}
                  disabled={isDeleting}
                />
              </Flex>
            </Table.TCell>
          </Table.TRow>
        ))}
      </Table.TBody>
    </Table>
  );
};
